import DetailTransferDetailIncome from './DetailTransferDetailIncome';

export default DetailTransferDetailIncome;
